// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#1c1c1c', // Your main background
            paper: '#2a2a2a',    // Background for cards, modals, etc.
        },
        primary: {
            main: '#12c099',
        },
        text: {
            primary: '#ffffff',
        },
        // Add a divider color to match your theme
        divider: '#3a3a3a',
    },
});

export default theme;
